import server from './server.js';
//  查询自定义方案是否存在
export const getProgrammeCustomExist = (params) => {
  return server({
    url: `/programme-custom/searchList/getProgrammeCustomExist`,
    method: 'POST',
    data: params,
  });
};

//  编辑或添加自定义方案详情,id为空为添加
export const addProgrammeCustomDetail = (params) => {
  return server({
    url: `/programme-custom/addProgrammeCustomDetail`,
    method: 'POST',
    data: params,
  });
};
//  获取单个自定义方案信息,方案路径通过页面传递
export const getProgrammeCustom = (params) => {
  return server({
    url: `/programme-custom/searchList/getProgrammeCustom`,
    method: 'POST',
    data: params,
  });
};

//  编辑或添加自定义方案,id为空为添加
export const addProgrammeCustom = (params) => {
  return server({
    url: `/programme-custom/addProgrammeCustom`,
    method: 'POST',
    data: params,
  });
};

//  删除自定义方案详情,只能删除草稿状态的
export const deleteProgrammeCustomDetail = (id) => {
  return server({
    url: `/programme-custom/deleteProgrammeCustomDetail/${id}`,
    method: 'POST',
  });
};

//  只提交自定义方案
export const customRelease = (proProgrammeId) => {
  return server({
    url: `/banner/customRelease`,
    method: 'POST',
    data: {
      proProgrammeId,
    },
  });
};
